module.exports = __webpack_public_path__ + "static/media/t1d3.3c81652a.jpg";